module.exports = __webpack_public_path__ + "static/media/dust.c88e9cb6.png";